<template>
  <w-icon-wrapper icon-name='work-close-icon'>
    <path
      id='Pfad_55659'
      d='M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z'
      data-name='Pfad 55659'
      fill='currentColor'
    />
    <path
      id='Pfad_55660'
      d='M16.707,7.293a1,1,0,0,0-1.414,0L12,10.586,8.707,7.293A1,1,0,0,0,7.293,8.707L10.586,12,7.293,15.293a1,1,0,1,0,1.414,1.414L12,13.414l3.293,3.293a1,1,0,0,0,1.414-1.414L13.414,12l3.293-3.293A1,1,0,0,0,16.707,7.293Z'
      data-name='Pfad 55660'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconClose' };
</script>
